
import "../CreateClient/CreateClient.css";
import React, { useEffect } from "react";
import { useGlobalContext } from "../../context";
import { radioType } from "../../interfaces";
import StarRateIcon from "@mui/icons-material/StarRate";

type propsData = {
    activePackage: string,
    customPackage: string,
    setActivePackage: (newActivePackage: string) => void,
    setCustomPackage: (newPackage: string) => void,
    client: any
}

function Package (props: propsData) {

    const {
        packageData,
        setPackageData,
    } = useGlobalContext()

    const { activePackage, setActivePackage, customPackage, setCustomPackage, client} = props;

    useEffect((): void => {
        if (client) {
            const findUserPackage: radioType | undefined = packageData.find((item: radioType) => item.title === client.packageName);
            if (findUserPackage) {
                setPackageData((packageData: radioType[]) => packageData.map((item: radioType) => item.title === client.packageName ? {
                    ...item,
                    active: true
                } : { ...item, active: false }));
            }
            else {
                setPackageData((packageData: radioType[]) => packageData.map((item: radioType) => item.title === "Other" ? {
                    ...item,
                    active: true
                } : { ...item, active: false }));
                setCustomPackage(client.packageName);
            }
        }
    }, [client]);

    const handleChange = (item: radioType): void => {
        setPackageData((packageData: radioType[]) => packageData.map((data: radioType) => data.id === item.id ? { ...data, active: true } : { ...data, active: false }));
        setCustomPackage("");
    }

    useEffect((): void => {
        const activePackage: radioType | undefined = packageData.find((item:radioType) => item.active);
        if (activePackage) setActivePackage(activePackage.title);
    }, [packageData])

    return (
        <div className="Package-container">
            <div className="createClient-form-package">
                <label className="required">Package <StarRateIcon style = {{color: "red", fontSize: "10px"}}/> </label>
            </div>
            <div className="createClient-package-box">
                {
                    packageData.map((item: radioType, index: number) => {
                        if (item.title !== "Other") {
                            return <div className="form-package-box" key = { index } onClick = { () => handleChange(item) }>
                                <input
                                    className = "packageOption"
                                    type = "radio"
                                    checked = { item.title === activePackage }
                                    name = { "package" }
                                />
                                <label htmlFor="socialPlus">{ item.title }</label>
                            </div>
                        }
                        else {
                            return (
                                <div className = "form-package-box" key = { index } onClick = { () => handleChange(item) }>
                                    <input
                                        className = "packageOption"
                                        type = "radio"
                                        checked = { item.title === activePackage }
                                        name = {"package"}
                                    />
                                    {
                                        activePackage === 'Other' ?
                                            <input
                                                type = "text"
                                                placeholder = "Package Name"
                                                value = { customPackage }
                                                onChange = {e => setCustomPackage(e.target.value)}
                                                className = "custom-package-input"
                                            />
                                        :
                                            <label htmlFor="socialOther">{ item.title }</label>
                                    }
                                </div>
                            )
                        }
                    })
                }
            </div>
        </div>
    )
}

export default Package
